// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.density-panel {
  background: #ffffff;
}

.density-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.65rem 1rem;
}

.test-detail-section {
  border: 1px solid #e3e8ef;
  border-radius: 4px;
  padding: 0.65rem;
  background: #ffffff;
}

.test-detail-title {
  margin: 0 0 0.55rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #3f4954;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.test-detail-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.test-detail-label {
  margin: 0;
  font-size: 0.85rem;
  color: #555;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-overview/test-details/job-request-test-density-detail.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,2DAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AACF;;AAEA;EACE,SAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AACF","sourcesContent":[".density-panel {\n  background: #ffffff;\n}\n\n.density-fields {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 0.65rem 1rem;\n}\n\n.test-detail-section {\n  border: 1px solid #e3e8ef;\n  border-radius: 4px;\n  padding: 0.65rem;\n  background: #ffffff;\n}\n\n.test-detail-title {\n  margin: 0 0 0.55rem;\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #3f4954;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.test-detail-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.test-detail-label {\n  margin: 0;\n  font-size: 0.85rem;\n  color: #555;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
